/* My Elegant Horse – valmiit lisäosat varastohupussa ja Ratsukellarin varasto.
   Jos valitulla koolla on saldoa ja versioon on merkitty valmiit lisäosat (metakenttä custom.valmiit_varusteet: A2, A4, T, A2T, A4T),
   äänieristys- ja tarranauhavalinnat asetetaan hupun mukaisiksi. Jos asiakas muuttaa niitä, toimitusaika pitenee ja muutos tallentuu tilaukseen.
   Jos omaa saldoa ei ole mutta huppu on Ratsukellarin välitysvarastossa (custom.ratsukellari_saldo), näytetään "Ratsukellarin varastossa"
   ja sen hupun valmiit lisäosat (custom.ratsukellari_varusteet) toimivat samoin kuin omassa varastossa. */
(function () {
  var pendingNote = null;
  var RK_STYLE = 'display: block; font-size: 11px; line-height: 1.25; margin-top: 2px; font-weight: 500; letter-spacing: .02em; color: ';

  function kuvaus(code) {
    var osat = [];
    if (/A2/.test(code)) osat.push('2 mm äänieristys');
    if (/A4/.test(code)) osat.push('4 mm äänieristys');
    if (/T/.test(code)) osat.push('tarranauhat');
    return osat.join(' ja ');
  }
  function valinta(sound, velcro) {
    var osat = [];
    osat.push(sound && sound !== 'Ei' ? sound + ' äänieristys' : 'ei äänieristystä');
    osat.push(velcro === 'Kyllä' ? 'tarranauhat' : 'ei tarranauhoja');
    return osat.join(', ');
  }

  // Äänieristyksen hinnat (samat kuin Ratsukellarissa). Tuotesivun pohja käyttää samoja hintoja; erotus lisätään vain, jos ne joskus eroavat.
  var AE = { '2 mm': 8, '4 mm': 10 }, AE_POHJA = { '2 mm': 8, '4 mm': 10 };
  function aanieristys(v, s) {
    (v.sounds || []).forEach(function (o) { var m = (o.label || '').match(/^(2 mm|4 mm)/); if (m) o.label = m[1] + ' +' + AE[m[1]] + ' €'; });
    var ero = (AE[s.sound] || 0) - (AE_POHJA[s.sound] || 0);
    if (ero) {
      var total = (parseFloat(v.priceText) || 0) + ero * (s.qty || 1);
      v.priceText = total + ' €';
      if (!s.added && /–/.test(v.addLabel || '')) v.addLabel = 'Lisää ostoskoriin – ' + total + ' €';
    }
    (v.panels || []).forEach(function (p) { if (p.body) p.body = p.body.replace('4 mm (+8 €)', '4 mm (+10 €)').replace('2 mm (+6 €)', '2 mm (+8 €)'); });
    return v;
  }

  // Shining Star: kiinnityksen voi vaihtaa tilauksen mukaan, joten saman koon saldot (oma ja Ratsukellari) näytetään kummallekin kiinnitykselle.
  // Varastohupun oma kiinnitys (kummassa versiossa saldo on) talteen MEH_KIIN-tauluun: esivalintaa ja tilauksen merkintää varten.
  var KOOT = ['Pony small', 'Pony', 'Cob small', 'Cob', 'Full small', 'Full', 'X-Full small', 'X-Full'];
  function yhdistaKiinnitykset(s) {
    if (yhdistaKiinnitykset.tehty || typeof window.MEH_VARIANT !== 'function' || !window.MEH || !MEH.stock) return;
    yhdistaKiinnitykset.tehty = true;
    var RK = window.MEH_RK = window.MEH_RK || {}, RKV = window.MEH_RKV = window.MEH_RKV || {}, tehdyt = {};
    KOOT.forEach(function (z) {
      try {
        var n = MEH_VARIANT({ size: z, base: s.base, attach: 'Naruilla' }), k = MEH_VARIANT({ size: z, base: s.base, attach: 'Kumilenkillä' });
        if (!n || !k || n.id === k.id || tehdyt[n.id]) return;
        tehdyt[n.id] = true;
        var a = String(n.id), b = String(k.id), KI = window.MEH_KIIN = window.MEH_KIIN || {};
        KI[a] = KI[b] = { naru: Math.max(0, MEH.stock[a] || 0), kumi: Math.max(0, MEH.stock[b] || 0) };
        var q = (MEH.stock[a] || 0) + (MEH.stock[b] || 0); MEH.stock[a] = MEH.stock[b] = q;
        var r = (RK[a] || 0) + (RK[b] || 0); if (r) RK[a] = RK[b] = r;
        if (RKV[a] && !RKV[b]) RKV[b] = RKV[a]; else if (RKV[b] && !RKV[a]) RKV[a] = RKV[b];
      } catch (e) {}
    });
  }

  // Tuotesivulle tultaessa valitaan valmiiksi koko, jota on varastossa: ensin oma varasto, sitten Ratsukellari (oletus Full small, jos se on varastossa).
  function valitseVarastokoko(self, s) {
    if (self._kokoValittu || typeof window.MEH_VARIANT !== 'function' || !window.MEH || !MEH.stock) return;
    self._kokoValittu = true;
    var tiedot = function (z) {
      var vr; try { vr = MEH_VARIANT({ size: z, base: s.base, attach: s.attach || '' }) || MEH_VARIANT({ size: z, base: s.base, attach: '' }); } catch (e) {}
      var id = vr ? String(vr.id) : '';
      return { q: MEH.stock[id] || 0, rk: (window.MEH_RK || {})[id] || 0 };
    };
    var nyt = tiedot(s.size);
    if (nyt.q > 0) return;
    var koot = KOOT;
    var oma = koot.filter(function (z) { return tiedot(z).q > 0; })[0];
    var valinta = oma || (nyt.rk > 0 ? null : koot.filter(function (z) { return tiedot(z).rk > 0; })[0]);
    if (valinta && valinta !== s.size) setTimeout(function () { self.setState({ size: valinta, added: false }); }, 0);
  }

  // Omat mitat: hinta lähimmän vakiokoon mukaan, joka lasketaan mitoista koko-oppaan taulukolla (sama kuin hallintaportaalin lib/kokoopas.js)
  // Vaihteluväli koon mukaan (small ja normaalikoko yhdessä; small-koon B, C ja D ovat 1 cm pienemmät)
  var KOKOOPAS_POHJA = { B: [[6, 8], [8, 10], [11, 13], [13, 15]], C: [[12, 14], [14, 16], [16, 18], [18, 20]], D: [[28, 30], [31, 33], [37, 39], [40, 42]] };
  // Mitta A koon small- ja normaaliversion yhteinen vaihteluväli (Shining Starin normaalikoon etuosa pidempi)
  var KOKOOPAS_A = { pearl: [[17, 20], [20, 23], [23, 26], [26, 29]], star: [[25, 28], [30, 35], [34, 37], [37, 40]] };
  var VAKIOKOOT = ['Pony', 'Cob', 'Full', 'X-Full'];
  function kokoelmaSivulta() {
    var p = location.pathname + ' ' + document.title.toLowerCase();
    return /pitka|shining star/.test(p) ? 'star' : /nelioreunainen|sparkling diamond/.test(p) ? 'diamond' : 'pearl';
  }
  function lahinKoko(kokoelma, m) {
    var A = KOKOOPAS_A[kokoelma !== 'star' ? 'pearl' : 'star'];
    var valit = { a: A, b: KOKOOPAS_POHJA.B, c: KOKOOPAS_POHJA.C, d: KOKOOPAS_POHJA.D };
    var pisteet = [0, 0, 0, 0], mittoja = 0;
    Object.keys(valit).forEach(function (k) {
      var x = parseFloat(String((m || {})[k] == null ? '' : m[k]).replace(',', '.'));
      if (!(x > 0)) return;
      mittoja++;
      var vali = valit[k], keski = vali.map(function (v) { return (v[0] + v[1]) / 2; }), askel = (keski[3] - keski[0]) / 3;
      vali.forEach(function (v, i) { var e = x < v[0] ? v[0] - x : x > v[1] ? x - v[1] : 0; pisteet[i] += Math.pow(e / askel, 2) + Math.pow((x - keski[i]) / askel, 2) * 0.1; });
    });
    return mittoja ? VAKIOKOOT[pisteet.indexOf(Math.min.apply(null, pisteet))] : null;
  }

  // Kokoelmakuvaukset konseptioppaan mukaan
  var PEARL = 'Pyöreä, aaltoileva reuna ja hienostunut koristelu: koristenyörit, helminauhat ja strassinauhat.';
  function kokoelmateksti(t) { return typeof t === 'string' ? t.replace(/^Pyöreä, aaltoileva reuna ja hienostunut koristelu(: helminauhat ja strassinauhat)?\./, PEARL) : t; }

  // Merseroidusta puuvillalangasta tehdyt (tuotteen tagi "merseroitu puuvilla" → window.MEH_MERSEROITU): lanka esittelyyn
  var MERSEROITU = 'Tehty käsin merseroidusta puuvillalangasta, joka on kiiltävämpää kuin tavallinen puuvillalanka.';
  function lankateksti(t) {
    if (!window.MEH_MERSEROITU || typeof t !== 'string' || t.indexOf('merseroidusta') >= 0) return t;
    return /Tehty käsin puuvillalangasta\./.test(t) ? t.replace(/Tehty käsin puuvillalangasta\./, MERSEROITU) : t + ' ' + MERSEROITU;
  }

  // Materiaalit ja hoito: lanka ja korvien kangas tuotteen tageista (merseroitu puuvilla, korvat lycra)
  function materiaalit(panels) {
    var lause = 'Korvahuppu on tehty ' + (window.MEH_MERSEROITU ? 'merseroidusta ' : '') + 'puuvillalangasta ja korvat ovat ' + (window.MEH_LYCRA ? 'lycraa' : 'trikookangasta') + '.';
    (panels || []).forEach(function (p) { if (p && typeof p.body === 'string') p.body = p.body.replace(/^Korvahuppu on tehty [^.]*?puuvillalangasta ja korvat ovat (lycraa|trikookangasta)\./, lause); });
    return panels;
  }

  function product(Comp) {
    return class extends Comp {
      renderVals() { yhdistaKiinnitykset(this.state); valitseVarastokoko(this, this.state); var v = aanieristys(this._valmiitVals(), this.state); v.desc = lankateksti(kokoelmateksti(v.desc)); v.panels = materiaalit(v.panels); return v; }
      _valmiitVals() {
        var v = super.renderVals(), s = this.state, self = this;
        if (typeof window.MEH_VARIANT !== 'function') return v;
        var RK = window.MEH_RK || {};
        var tiedot = function (size) {
          try {
            var vr = MEH_VARIANT({ size: size, base: s.base, attach: v.hasAttach ? s.attach : '' });
            var vid = vr ? String(vr.id) : '';
            return { id: vid, q: window.MEH && MEH.stock && typeof MEH.stock[vid] === 'number' ? MEH.stock[vid] : 0, rk: RK[vid] || 0 };
          } catch (e) { return { id: '', q: 0, rk: 0 }; }
        };
        // Kokonapit: Ratsukellarissa oleva koko merkitään, kun omaa saldoa ei ole
        (v.sizes || []).forEach(function (b) {
          if (b.label === 'Omat mitat') return;
          var t = tiedot(b.label);
          if (t.q > 0 || t.rk <= 0) return;
          var on = s.size === b.label;
          b.note = '● Ratsukellarissa';
          b.noteStyle = RK_STYLE + (on ? '#E6CF9F' : '#8A6A2F');
          if (!on) b.style += '; border: 1.5px solid #B8975A; background: #FBF6EC';
        });
        if (s.size === 'Omat mitat') {
          // Hinnoittelukoko lasketaan mitoista: asiakas ei valitse sitä itse
          var lk = lahinKoko(kokoelmaSivulta(), s.m);
          if (lk && lk !== s.base) setTimeout(function () { self.setState({ base: lk, added: false }); }, 0);
          var tyyli = (typeof self.pill === 'function' ? self.pill(true) : '') + '; grid-column: 1 / -1; cursor: default';
          // Mittatilauslisä: Pony ja Cob +14 €, Full ja X-Full +16 € vakiokoon (small) hinnasta
          var lisa = function (k) { return /Full/.test(k) ? 16 : 14; }, eur = function (x) { return (x % 1 ? x.toFixed(2).replace('.', ',') : String(x)) + ' €'; };
          var perus = null;
          try { var pv = lk && MEH_VARIANT({ size: lk + ' small', base: lk, attach: v.hasAttach ? s.attach : '' }); perus = pv ? pv.price / 100 : null; } catch (e) {}
          v.bases = [{ label: lk ? lk + ' – laskettu mitoistasi' + (perus ? ' · ' + eur(perus) + ' + ' + lisa(lk) + ' €' : '') : 'Lasketaan mitoistasi, kun kirjoitat mitat', pick: function () {}, style: tyyli }];
          var selitys = lk && perus ? 'Hinta on mitoistasi lasketun vakiokoon ' + lk + ' hinta ' + eur(perus) + ' + mittatilauslisä ' + lisa(lk) + ' € = ' + eur(perus + lisa(lk)) + '.'
            : 'Mittatilauslisä on vakiokoon hintaan +14 € (Pony ja Cob) tai +16 € (Full ja X-Full).';
          v.stockMsg = (v.stockMsg ? v.stockMsg + ' ' : '') + selitys;
          return v;
        }
        var nyt = tiedot(s.size), id = nyt.id;
        // Lähde: oma varasto ensin, sitten Ratsukellari. Kummassakin valmiit lisäosat esivalitaan samalla tavalla.
        var oma = nyt.q > 0, rkssa = !oma && nyt.rk > 0;
        // Shining Star: varastohupun oma kiinnitys. Esivalitaan, kun koko vaihtuu; asiakas voi vaihtaa sen.
        var kin = v.hasAttach && oma ? (window.MEH_KIIN || {})[id] : null;
        var fyys = kin ? (kin.kumi > 0 && !(kin.naru > 0) ? 'Kumilenkillä' : kin.naru > 0 && !(kin.kumi > 0) ? 'Naruilla' : '') : '';
        var kiinAvain = v.title + '|' + s.size;
        if (fyys && self._kiinId !== kiinAvain) { self._kiinId = kiinAvain; if (s.attach !== fyys) setTimeout(function () { self.setState({ attach: fyys, added: false }); }, 0); }
        var raaka = oma ? ((window.MEH_VALMIIT || {})[id] || '') : rkssa ? ((window.MEH_RKV || {})[id] || '') : '';
        var code = /^(A2|A4)?T?$/.test(raaka) && raaka !== '' ? raaka : '';
        var want = { sound: /A2/.test(code) ? '2 mm' : /A4/.test(code) ? '4 mm' : 'Ei', velcro: /T/.test(code) ? 'Kyllä' : 'Ei' };
        var cur = { sound: s.sound || 'Ei', velcro: s.velcro || 'Ei' };
        var avain = id + (oma ? ':oma' : rkssa ? ':rk' : '');

        // Koko vaihtui: asetetaan valinnat hupun mukaisiksi tai palautetaan, jos ne oli asetettu automaattisesti
        if (self._valmisId !== avain) {
          var edellinen = self._valmisAuto;
          self._valmisId = avain;
          self._valmisAuto = code ? want : null;
          var uusi = null;
          if (code) uusi = want;
          else if (edellinen && cur.sound === edellinen.sound && cur.velcro === edellinen.velcro) uusi = { sound: 'Ei', velcro: 'Ei' };
          if (uusi && (uusi.sound !== cur.sound || uusi.velcro !== cur.velcro)) setTimeout(function () { self.setState({ sound: uusi.sound, velcro: uusi.velcro, added: false }); }, 0);
        }

        var alku = oma ? 'Varastossa ' + nyt.q + ' kpl' : 'Ratsukellarin varastossa';
        var ajat = oma ? ['1–2', '1–4'] : ['2–4', '2–6'];
        var sama = cur.sound === want.sound && cur.velcro === want.velcro;
        var toimitus = rkssa ? 'Heti noudettavissa Ratsukellarista (Pirkkala) tai postitetaan ' + ajat[0] + ' arkipäivässä.' : 'Postitetaan ' + ajat[0] + ' arkipäivässä.';
        var notes = [];
        if (rkssa) notes.push({ avain: 'Toimitus Ratsukellarin varastosta: ' + v.title + ', ' + s.size, arvo: 'Huppu haetaan Ratsukellarista' });
        if (code) {
          v.stockMsg = sama
            ? alku + ' – valmiina paikallaan: ' + kuvaus(code) + '. ' + toimitus
            : alku + ' – tässä hupussa on valmiina ' + kuvaus(code) + '. Muutan lisäosat valintasi mukaan, jolloin huppu postitetaan ' + ajat[1] + ' arkipäivässä.';
          if (!sama) notes.push({ avain: 'Varastohupun muutos: ' + v.title + ', ' + s.size, arvo: 'Valmiina ' + kuvaus(code) + ' → asiakas valitsi: ' + valinta(cur.sound, cur.velcro) });
        } else if (rkssa) {
          var lisaa = cur.sound !== 'Ei' || cur.velcro === 'Kyllä';
          v.stockMsg = lisaa
            ? alku + ' – lisään valitsemasi lisäosat, jolloin huppu postitetaan ' + ajat[1] + ' arkipäivässä.'
            : alku + ' – heti noudettavissa Ratsukellarista (Pirkkala) tai postitetaan ' + ajat[0] + ' arkipäivässä.';
          if (lisaa) notes.push({ avain: 'Varastohupun muutos: ' + v.title + ', ' + s.size, arvo: 'Ratsukellarin huppuun lisätään: ' + valinta(cur.sound, cur.velcro) });
        }
        if (fyys && v.stockMsg) {
          var kNimi = fyys === 'Kumilenkillä' ? 'kumilenkki' : 'narut', kTyyppi = fyys === 'Kumilenkillä' ? 'kumilenkkikiinnitys' : 'narukiinnitys';
          v.stockMsg += s.attach === fyys ? ' Hupussa on valmiina ' + kTyyppi + '.' : ' Hupussa on valmiina ' + kTyyppi + ': vaihdan sen ' + (s.attach === 'Kumilenkillä' ? 'kumilenkkiin' : 'naruihin') + ' ennen postitusta.';
          if (s.attach !== fyys) notes.push({ avain: 'Varastohupun kiinnitys: ' + v.title + ', ' + s.size, arvo: 'Hupussa ' + kNimi + ' → asiakas valitsi ' + String(s.attach || '').toLowerCase() });
        }
        if (oma || rkssa) v.stockDot = '#4F7A4A';
        // Oman varaston hupun voi noutaa myös Ratsukellarista (kassalla toimitustapa "Nouto Ratsukellarista")
        if (oma && v.stockMsg) v.stockMsg += ' Voit myös noutaa sen Ratsukellarista (Pirkkala) ' + (/1–4 arkipäivässä/.test(v.stockMsg) ? '1–4' : '1–2') + ' arkipäivän kuluttua.';
        if (notes.length) ['add', 'buyNow'].forEach(function (k) {
          var f = v[k];
          if (typeof f === 'function') v[k] = function () { pendingNote = notes; return f.apply(this, arguments); };
        });
        return v;
      }
    };
  }

  // Kokoelmasivut: Varastossa-merkintä myös tuotteille, jotka ovat vain Ratsukellarissa
  function mallisto(Comp) {
    return class extends Comp {
      renderVals() {
        var v = super.renderVals(), s = this.state, H = window.MEH_HANDLE || {}, OMA = (window.MEH && MEH.__oma) || {}, RKT = window.MEH_RK_TUOTTEET || {};
        v.intro = kokoelmateksti(v.intro);
        (v.items || []).forEach(function (it) {
          var h = H[s.col + '|' + it.name];
          if (it.stock && !(OMA[h] > 0) && RKT[h] > 0) it.sub = 'Ratsukellarissa – heti noudettavissa';
        });
        return v;
      }
    };
  }
  // Tuotekohtaiset saldot (MEH.instock): lisätään Ratsukellarin kappaleet, ellei ne jo ole Shopifyn saldossa
  function lisaaRatsukellari() {
    if (!window.MEH || !MEH.instock || MEH.__oma) return;
    var RKT = window.MEH_RK_TUOTTEET || {}, oma = {};
    Object.keys(MEH.instock).forEach(function (h) { oma[h] = window.MEH_RK_SHOPIFY ? Math.max(0, MEH.instock[h] - (RKT[h] || 0)) : MEH.instock[h]; });
    if (!window.MEH_RK_SHOPIFY) Object.keys(RKT).forEach(function (h) { if (h !== '_') MEH.instock[h] = (MEH.instock[h] || 0) + RKT[h]; });
    MEH.__oma = oma;
  }

  // Ratsukellari-osiot (etusivu ja Usein kysyttyä): maininta verkkokaupasta tilaamisesta ja maksuttomasta noudosta Ratsukellarista
  var NOUTO = 'Voit myös tilata korvahupun verkkokaupastani ja noutaa sen Ratsukellarista maksutta. Ratsukellarin varastossa olevat korvahuput ovat noudettavissa heti, muut varastotuotteet 1–2 arkipäivässä – valitse kassalla toimitustavaksi nouto Ratsukellarista.';
  var AUKI = 'Ratsukellari on avoinna arkisin 12–18 ja lauantaisin 10–15.';
  function ratsukellariTeksti(h) {
    if (h.indexOf('data-meh-nouto') >= 0) return h;
    return h
      .replace(/(Korvahuput löytyvät myös Ratsukellarin verkkokaupasta\.<\/p>)/, '$1<p data-meh-nouto="1" style="margin: 12px 0 0; max-width: 560px; color: #FFFFFF; font-size: 17px">' + NOUTO + '</p>')
      .replace(/(Jasperintie 270 C 5, 33960 Pirkkala<\/div>)/, '$1<div style="color: #D6D6D6">Avoinna ma–pe 12–18, la 10–15</div>')
      .replace(/(jossa voit katsoa värejä läheltä ja tutustua kokoihin\.)/g, '$1 ' + NOUTO + ' ' + AUKI)
      // Asiakaspalvelu-sivun Ratsukellari-kortti ja ostoskorin toimitusteksti
      .replace(/(korvahuput löytyvät myös Ratsukellarin verkkokaupasta\.<\/p>)/, '$1<p data-meh-nouto="1" style="margin: 10px 0 0; color: #D6D6D6">Avoinna ma–pe 12–18, la 10–15. Verkkokaupastani tilatun korvahupun voit noutaa Ratsukellarista maksutta.</p>')
      .replace(/Toimitus on aina ilmainen – Postin Smartpost-automaattiin\./g, 'Toimitus on aina ilmainen – Postin Smartpost-automaattiin tai nouto Ratsukellarista (Pirkkala).');
  }

  // Omien mittojen ohjetekstit: koko lasketaan mitoista
  function mittaTeksti(h) {
    return h
      .replace(/>Lähin vakiokoko</, '>Hinnoittelukoko<')
      .replace('Hinta määräytyy tämän mukaan. Teen korvahupun silti mittojesi mukaan.', 'Koko lasketaan mitoistasi automaattisesti. Hinta on tämän vakiokoon hinta + mittatilauslisä 14 € (Pony, Cob) tai 16 € (Full, X-Full). Teen korvahupun silti tarkasti mittojesi mukaan.')
      .replace('Mittakentät avautuvat suoraan tuotesivulle.', 'Mittakentät avautuvat suoraan tuotesivulle. Hinta lasketaan mitoista automaattisesti.');
  }

  // Alalaidan Evästeasetukset-linkki: avaa Shopifyn evästevalinnat, jotta suostumuksen voi muuttaa tai perua
  function evasteLinkki(h) {
    if (h.indexOf('data-meh-evaste') >= 0) return h;
    return h.replace(/(>Oikeudellinen huomautus<\/a>)/, '$1<a href="#evasteasetukset" data-meh-evaste="1" style="color: #999999">Evästeasetukset</a>');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-meh-evaste], a[href="#evasteasetukset"]');
    if (!a) return;
    e.preventDefault();
    if (window.privacyBanner && typeof privacyBanner.showPreferences === 'function') privacyBanner.showPreferences();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var add = window.MEH_ADD, mount = window.MEH_MOUNT;
    if (typeof add === 'function') {
      // Muutos tallennetaan tilauksen lisätietoihin ennen kuin tuote lisätään koriin (myös Osta nyt -painikkeella)
      window.MEH_ADD = function () {
        var n = pendingNote, self = this, args = arguments;
        pendingNote = null;
        if (!n) return add.apply(self, args);
        var attrs = {};
        n.forEach(function (x) { attrs[x.avain] = x.arvo; });
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
          .catch(function () {}).then(function () { return add.apply(self, args); });
      };
    }
    if (typeof mount !== 'function') return;
    Object.defineProperty(window, 'MEH_MOUNT', {
      configurable: true, writable: true,
      value: function (root, id, Comp) {
        var C2 = Comp;
        try {
          // Kokoelmien pääkuvat vaihdettu 30.10.2026: uudet tiedostonimet, koska CDN pitää vanhat nimet välimuistissa
          // Uusi tuote, jota teeman luettelossa ei ole: lisätään ennen kuin sivu muodostetaan
          if (window.MEH && MEH.handle && !MEH.key) { var uusi = tuoteSivulta(); if (uusi) MEH.key = lisaaTuote(uusi) || MEH.key; }
          haeLisat();
          var UUDET = { 'meh-kokoelma-diamond.jpg': 'meh-kokoelma-diamond-3.jpg', 'meh-kokoelma-star.jpg': 'meh-kokoelma-star-3.jpg' };
          if (window.MEH_BLOB) Object.keys(MEH_BLOB).forEach(function (k) { if (UUDET[MEH_BLOB[k]]) MEH_BLOB[k] = UUDET[MEH_BLOB[k]]; });
          // Kun Ratsukellarin kappaleet ovat Shopifyn saldossa (oma varastopaikka), ne vähennetään tuotesivun omasta saldosta
          if (window.MEH_RK_SHOPIFY && window.MEH && MEH.stock && !MEH.__rkVahennetty) {
            Object.keys(window.MEH_RK || {}).forEach(function (k) { if (typeof MEH.stock[k] === 'number') MEH.stock[k] = Math.max(0, MEH.stock[k] - MEH_RK[k]); });
            MEH.__rkVahennetty = true;
          }
          lisaaRatsukellari();
          var t = document.getElementById(id);
          if (t) { var h0 = t.innerHTML, h1 = mittaTeksti(evasteLinkki(ratsukellariTeksti(h0))); if (h1 !== h0) t.innerHTML = h1; }
          if (t && t.innerHTML.indexOf('data-meh-page="Tuote"') >= 0) C2 = product(Comp);
          else if (t && t.innerHTML.indexOf('data-meh-page="Mallisto"') >= 0) C2 = mallisto(Comp);
        } catch (e) { C2 = Comp; }
        return mount.call(this, root, id, lisatKomponentti(C2));
      }
    });
  });

  // Uutiskirjeen tilauksen jälkeen Shopify palaa etusivulle osoitteeseen #meh-nl-form. Piilotettu lomake on sivun alussa,
  // joten sivu hyppäsi alkuun. Ohjataan paluu näkyvään klubilomakkeeseen, jonka painikkeessa lukee "Kiitos, olet nyt klubin jäsen!".
  var tilattu = /customer_posted=true/.test(location.search);
  if (location.hash === '#meh-nl-form' || (tilattu && !location.hash)) history.replaceState(null, '', location.pathname + location.search + '#klubi');
  // Tapahtumakylttien QR-koodi (#klubi): vieritetään etusivun klubilomakkeeseen. Sivu palauttaa vierityksen alkuun latautuessaan,
  // joten vieritys toistetaan muutaman sekunnin ajan, kunnes kenttä on näkyvissä, ellei kävijä itse vieritä.
  if (location.hash === '#klubi') {
    var kayttaja = false, kerrat = 0;
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, function () { kayttaja = true; }, { once: true, passive: true }); });
    var klubi = setInterval(function () {
      var k = document.getElementById('nl-email');
      if (kayttaja || ++kerrat > 30) return clearInterval(klubi);
      if (!k) return;
      var b = k.getBoundingClientRect();
      if (b.top < 0 || b.bottom > window.innerHeight) k.scrollIntoView({ block: 'center' });
      else if (kerrat > 10) clearInterval(klubi);
      if (!tilattu && document.activeElement !== k) try { k.focus({ preventScroll: true }); } catch (e) {}
    }, 300);
  }


  // ---------- Uudet huput teeman tuoteluetteloon ----------
  // Teeman sivukomponenteissa on kiinteä tuoteluettelo, johon ohjelmalla luodut uudet huput eivät kuulu. Siksi uuden hupun
  // tuotesivu näytti Musta pitkä -hupun nimen, kokoelman ja kiinnitysvalinnan, eikä huppu näkynyt kokoelmasivulla.
  // Puuttuvat huput lisätään luetteloon renderöinnin ajaksi samassa muodossa: [kokoelma, nimi, hinta, väri, värikoodi, kuva, hevoskuva].
  var LISAT = [], KOMPONENTIT = [], VARIKOODIT = {};
  var VARIT = { musta: '#151515', valkoinen: '#F4F4F2', harmaa: '#8C8F93', beige: '#D8C3A5', ruskea: '#6B4A32', punainen: '#B3202A', viininpunainen: '#6E1F2C', roosa: '#E8B4B8', pinkki: '#E05A9A', violetti: '#6B3FA0', tummansininen: '#1F2A4D', kirkkaansininen: '#1E5BC6', vaaleansininen: '#9CC3E6', oranssi: '#E07A2E', vihreä: '#2F6B3A', keltainen: '#E8C547' };
  var kokoelmaNimesta = function (t) { t = String(t || '').toUpperCase(); return /PITKÄ/.test(t) ? 'star' : /NELIÖ/.test(t) ? 'diamond' : /PYÖREÄ/.test(t) ? 'pearl' : null; };
  // Kuvatunnus /_blob/-osoitteeseen: 32 heksamerkkiä tuotteen osoitteesta
  var tunnus = function (teksti, n) { var h = 2166136261, out = ''; for (var k = 0; k < 4; k++) { for (var i = 0; i < teksti.length; i++) { h ^= teksti.charCodeAt(i) + k * 31 + n; h = Math.imul(h, 16777619) >>> 0; } out += ('00000000' + h.toString(16)).slice(-8); } return out; };
  var isolla = function (x) { return x.charAt(0).toUpperCase() + x.slice(1); };
  function lisaaTuote(t) { // t = { handle, title, hinta (€), kuvat: [url] }
    var col = kokoelmaNimesta(t.title); if (!col || !t.handle) return null;
    var H = window.MEH_HANDLE = window.MEH_HANDLE || {};
    for (var k in H) if (H[k] === t.handle) return k; // on jo teeman luettelossa
    var osat = String(t.title).replace(/\s+/g, ' ').trim().split(/ korvahuppu ?/i);
    var vari = osat[0].replace(/ (pyöreäreunainen|neliöreunainen|pitkä)$/i, '').trim().toLowerCase(), koriste = (osat[1] || '').trim().toLowerCase();
    var nimi = isolla(vari) + (koriste ? ', ' + koriste : ''), avain = col + '|' + nimi;
    var kuvat = (t.kuvat || []).filter(function (u) { return u && !/mittaohje/.test(u); });
    var hevonen = kuvat.filter(function (u) { return /kollaasi/.test(u); })[0] || kuvat.filter(function (u, i) { return i >= 2; })[0] || kuvat[1] || kuvat[0];
    var B = window.MEH_BLOB = window.MEH_BLOB || {}, k1 = tunnus(t.handle, 1), k2 = tunnus(t.handle, 2);
    B[k1] = kuvat[0] || ''; B[k2] = hevonen || '';
    H[avain] = t.handle;
    LISAT.push([col, nimi, t.hinta || 0, vari, VARIKOODIT[vari] || VARIT[vari] || '#B8A99A', k1, k2]);
    return avain;
  }
  // Koko tuoteluettelo: sisältää vähintään kaksi kokoelmaa (kokoelman oma osajoukko ei kelpaa) eikä vielä lisättyjä huppuja
  var onLuettelo = function (a) {
    if (!LISAT.length || !Array.isArray(a) || a.length < 10 || !Array.isArray(a[0]) || typeof a[0][2] !== 'number' || a.indexOf(LISAT[0]) >= 0) return false;
    var cols = {}; a.forEach(function (x) { if (x && x[0]) cols[x[0]] = 1; if (x && x[3] && x[4]) VARIKOODIT[x[3]] = VARIKOODIT[x[3]] || x[4]; });
    return Object.keys(cols).length >= 2;
  };
  function lisatMukaan(fn) {
    if (!LISAT.length) return fn();
    var F = Array.prototype.find, S = Array.prototype.filter;
    LISAT.forEach(function (l) { if (VARIKOODIT[l[3]]) l[4] = VARIKOODIT[l[3]]; });
    Array.prototype.find = function (cb, th) { var r = F.call(this, cb, th); return r === undefined && onLuettelo(this) ? F.call(LISAT, cb, th) : r; };
    Array.prototype.filter = function (cb, th) { var r = S.call(this, cb, th); return onLuettelo(this) ? r.concat(S.call(LISAT, cb, th)) : r; };
    try { return fn(); } finally { Array.prototype.find = F; Array.prototype.filter = S; }
  }
  function lisatKomponentti(C) {
    if (typeof C !== 'function') return C;
    return class extends C {
      constructor(props) { super(props); KOMPONENTIT.push(this); }
      renderVals() { var self = this; return lisatMukaan(function () { return C.prototype.renderVals.call(self); }); }
    };
  }
  // Tuotesivu: nykyinen tuote suoraan sivun tiedoista
  function tuoteSivulta() {
    var M = window.MEH || {};
    if (!M.handle || !M.title) return null;
    var hinnat = (M.variants || []).filter(function (v) { return !/omat/i.test(v.title || ''); }).map(function (v) { return v.price / 100; });
    return { handle: M.handle, title: M.title, hinta: hinnat.length ? Math.min.apply(null, hinnat) : 0,
      kuvat: (M.media || []).map(function (u) { return String(u).indexOf('//') === 0 ? 'https:' + u : u; }) };
  }
  // Muut sivut: kaupan julkiset tuotetiedot (välimuistissa 10 min)
  var haettu = false;
  function haeLisat() {
    if (haettu) return; haettu = true;
    var kayta = function (lista) {
      var ennen = LISAT.length;
      lista.forEach(function (p) {
        if (!/korvahuppu/i.test(p.title)) return;
        var hinnat = (p.variants || []).filter(function (v) { return !/omat/i.test(v.title || ''); }).map(function (v) { return Number(v.price); });
        lisaaTuote({ handle: p.handle, title: p.title, hinta: hinnat.length ? Math.min.apply(null, hinnat) : 0, kuvat: (p.images || []).map(function (i) { return i.src; }) });
      });
      if (LISAT.length > ennen) KOMPONENTIT.forEach(function (c) { try { c.setState({}); } catch (e) {} });
    };
    try { var v = JSON.parse(sessionStorage.getItem('meh-lisat') || 'null'); if (v && Date.now() - v.t < 600000) return kayta(v.lista); } catch (e) {}
    fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      var lista = (d.products || []).map(function (p) { return { handle: p.handle, title: p.title, variants: (p.variants || []).map(function (v) { return { title: v.title, price: v.price }; }), images: (p.images || []).map(function (i) { return { src: i.src }; }) }; });
      try { sessionStorage.setItem('meh-lisat', JSON.stringify({ t: Date.now(), lista: lista })); } catch (e) {}
      kayta(lista);
    }).catch(function () {});
  }
})();
